import { usePageOption } from 'hooks';
import { EnrollQuery } from 'queries';
import { useParams } from 'react-router-dom';

function useEroll(
  name?: string,
  attendanceStatus?: string,
  selectionStatus?: string,
) {
  const { id } = useParams<{ id: string }>();
  const pageState = usePageOption();
  const { data } = EnrollQuery.useGetAll({
    page: pageState.pageOption.page,
    size: pageState.pageOption.size,
    eventId: Number(id),
    ...(name ? { name } : {}),
    ...(attendanceStatus ? { attendanceStatus } : {}),
    ...(selectionStatus ? { selectionStatus } : {}),
  });

  return { data, pageState };
}

export default useEroll;
